import { Download, FileText, FileArchive, FileSpreadsheet, File } from "lucide-react";

interface FileDownloadProps {
  url: string;
  fileName: string;
  fileSize?: number;
  contentType?: string;
}

export default function FileDownload({
  url,
  fileName,
  fileSize,
  contentType,
}: FileDownloadProps) {
  const getFileIcon = () => {
    if (!contentType) return <File className="w-8 h-8" />;

    if (contentType.includes("pdf")) {
      return <FileText className="w-8 h-8 text-red-600" />;
    } else if (
      contentType.includes("zip") ||
      contentType.includes("rar")
    ) {
      return <FileArchive className="w-8 h-8 text-yellow-600" />;
    } else if (
      contentType.includes("sheet") ||
      contentType.includes("excel")
    ) {
      return <FileSpreadsheet className="w-8 h-8 text-green-600" />;
    } else if (
      contentType.includes("presentation") ||
      contentType.includes("powerpoint")
    ) {
      return <FileText className="w-8 h-8 text-blue-600" />;
    } else if (
      contentType.includes("document") ||
      contentType.includes("word")
    ) {
      return <FileText className="w-8 h-8 text-blue-600" />;
    }

    return <File className="w-8 h-8 text-gray-600" />;
  };

  const formatFileSize = (bytes?: number): string => {
    if (!bytes) return "";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  };

  const handleDownload = () => {
    window.open(url, "_blank");
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all">
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0">{getFileIcon()}</div>
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-gray-800 truncate">{fileName}</h4>
          {fileSize && (
            <p className="text-sm text-gray-600">{formatFileSize(fileSize)}</p>
          )}
        </div>
        <button
          onClick={handleDownload}
          className="flex-shrink-0 bg-gradient-to-r from-blue-600 to-pink-600 text-white px-4 py-2 rounded-xl font-semibold hover:shadow-lg transition-all flex items-center gap-2"
        >
          <Download className="w-4 h-4" />
          ดาวน์โหลด
        </button>
      </div>
    </div>
  );
}
